<template>
    <baidu-map
        class="view-map"
        :center="center"
        :zoom='zoom'
        :scroll-wheel-zoom='true'>
        <!--//地理位置的搜索功能-->
        <!--<bm-local-search-->
                <!--:keyword="keyword"-->
                <!--:auto-viewport="true"-->
                <!--:location="location"-->
                <!--style="display:none;"-->
        <!--&gt;</bm-local-search>-->
        <!--//缩放比例尺的展示-->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <!--//定位-->
        <!--<bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :showAddressBar="true"
                :autoLocation="true"
        ></bm-geolocation>-->
        <!--//添加一个小红点的，并将当前的经纬度写入数据中-->
        <bm-marker :position="{'lng':center.lng, 'lat': center.lat}"></bm-marker>
    </baidu-map>
</template>

<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map'
    export default {
        name: 'timeCounter',
        props: {
            latitude:{
                type:Number,
                default:30.573037
            },
            longitude:{
                type:Number,
                default:104.06287
            },
            cityName:String,
            address:{
                type:String,
                default:'请搜索关键字'
            }
        },
        components:{
            BaiduMap
        },
        data() {
            return {
                baidumapSwitch:false,
                center:{
                    lng:this.longitude,
                    lat:this.latitude
                },
                zoom: 13,
                location: this.cityName,
                keyword: this.address,
            }
        },
        computed: {
        },
        mounted(){

        },
        methods: {
            //百度地图初始化（这个一定要！否则地图回加载不出来）
            handler({ BMap, map }) {
                console.log('map',BMap, map);
            },
            //点击获取到当前经纬度
            getClickInfo(e) {
                console.log(e.point.lng);
                console.log(e.point.lat);
                this.center.lng = e.point.lng;
                this.center.lat = e.point.lat;
            },
            //双向绑定经纬度以及缩放尺寸
            syncCenterAndZoom(e) {
                const { lng, lat } = e.target.getCenter();
                this.center.lng = lng;
                this.center.lat = lat;
                // this.zoom = e.target.getZoom();
            },
            //经纬度同步
            baidumap(){
                this.baiduDevicelocationx = this.center.lng
                this.baiduDevicelocationy = this.center.lat
            }
        }
    }
</script>

<style scoped lang="scss">
    .view-map{
        width:100%;
        height:100%;
    }
</style>